import * as React from 'react';
import Note from './note';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

interface PinnedNotesListProps {
    items: any[];
}

class PinnedNotesList extends React.Component<PinnedNotesListProps> {
    render() {
        const { items, onDragEnd } = this.props;

        return (

            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="bookmarkList">
                    {(provided) => (
                        <div
                            className={`hero-menucontent__list ${items.length == 0 ? 'no-list' : ''}`}
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                        >
                            {items.map((note, index) => (
                                <Draggable
                                    key={note.id || index}
                                    draggableId={note.id || index.toString()}
                                    index={index}
                                >
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            className="hero-menucontent__list-item-draggable"
                                        >
                                            <Note note={note} key={index} />
                                        </div>
                                    )}
                                </Draggable>
                            ))}

                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>

        );
    }
}

export default PinnedNotesList;